import React from 'react'

import { Modal, Button, Tabs, Row, Col, Form } from '_zari/core'

import * as TurnoService from 'services/turno.service'
import * as CuadresCombustiblesService from 'services/cuadresCombustibles.service'
import * as GuiasVentaService from 'services/guiasVenta.service'

import { TiposDocumentoSunatConstant } from 'constants/index'

import * as Sections from './sections'

const MovimientosTurnoModal = ({ show, handleClose, self, id }) => {
  const [turnoData, setTurnoData] = React.useState({})
  const [movimientosValesData, setMovimientosValesData] = React.useState({})
  const [serafinadoData, setSerafinadoData] = React.useState([])
  const [consumoData, setConsumoData] = React.useState([])
  const [contometroData, setContometroData] = React.useState([])

  React.useEffect(() => {
    const filtrosConsultas = { self: self ? self : undefined, id: id ? id : undefined }
    const filtrosConsultasIdTurno = { self: self ? self : undefined, idTurno: id ? id : undefined }

    TurnoService.obtenerReporteActualxFiltro(filtrosConsultas).then(({ data }) => {
      setTurnoData(data)
    })

    CuadresCombustiblesService.obtenerAsDetallesTurnos(filtrosConsultasIdTurno).then(({ data }) => {
      setContometroData(data)
    })

    GuiasVentaService.obtenerResumenMovimientoxIdTurnoAsInfoVista({
      ...filtrosConsultasIdTurno,
      tipoDocumentoSunat: TiposDocumentoSunatConstant.SERAFINADO
    }).then(({ data }) => {
      setSerafinadoData(data)
    })

    GuiasVentaService.obtenerResumenMovimientoxIdTurnoAsInfoVista({
      ...filtrosConsultasIdTurno,
      tipoDocumentoSunat: TiposDocumentoSunatConstant.CONSUMO
    }).then(({ data }) => {
      setConsumoData(data)
    })

    GuiasVentaService.obtenerResumenMovimientoxIdTurnoAsInfoVista({
      ...filtrosConsultasIdTurno,
      tipoDocumentoSunat: TiposDocumentoSunatConstant.OTROS
    }).then(({ data }) => {
      setMovimientosValesData(data)
    })
  }, [self, id])

  return (
    <Modal show={show} size='xl'>
      <Modal.Header>
        <Modal.Title>Movimientos del Turno</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='USUARIO' htmlFor='input-usuario-movmientos' md={2} alignRightAt='md' />
              <Col md={10}>
                <Form.InputText
                  id='input-usuario-movmientos'
                  name='input-usuario-movmientos'
                  placeholder={turnoData.usuario || '--'}
                  disabled
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row className='mt-4'>
          <Col md={12}>
            <Tabs defaultActiveKey='1' id='movimientos-tab'>
              <Tabs.Tab eventKey='1' title='Ventas'>
                <Sections.ResumenVentasSection self={self} id={id} />
              </Tabs.Tab>
              <Tabs.Tab eventKey='2' title='Vales'>
                <Sections.ValesSection sectionData={movimientosValesData || {}} />
              </Tabs.Tab>
              <Tabs.Tab eventKey='3' title='Serafinado'>
                <Sections.SerafinadoSection sectionData={serafinadoData || {}} />
              </Tabs.Tab>
              <Tabs.Tab eventKey='4' title='Consumo'>
                <Sections.ConsumoSection sectionData={consumoData || {}} />
              </Tabs.Tab>
              <Tabs.Tab eventKey='5' title='Contometro'>
                <Sections.ContometroSection sectionData={contometroData || {}} />
              </Tabs.Tab>
            </Tabs>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' outline onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(MovimientosTurnoModal)
